var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { createConfig, WagmiProvider } from 'wagmi';
import { connectorsForWallets } from '../wallets/connectorsForWallets.js';
import { http } from 'viem';
import { computeWalletConnectMetaData } from '../utils/computeWalletConnectMetaData.js';
import { EvmExternalWalletContext, EvmExternalWalletProvider } from './EvmExternalWalletContext.js';
import { useExternalWalletProviderStore } from '@usecapsule/react-sdk';
const createDefaultTransports = (chains) => {
    const transportsObject = chains.reduce((acc, chain) => {
        const key = chain.id;
        acc[key] = http(); // Type assertion here
        return acc;
    }, {});
    return transportsObject;
};
export function CapsuleEvmProvider(_a) {
    var { children, config: _config } = _a, wagmiProviderProps = __rest(_a, ["children", "config"]);
    const updateExternalWalletProviderState = useExternalWalletProviderStore(state => state.updateState);
    const EvmProvider = useExternalWalletProviderStore(state => state.EvmProvider);
    const evmContext = useExternalWalletProviderStore(state => state.evmContext);
    const { projectId, appName, appDescription, appIcon, appUrl, wallets, chains, transports } = _config, wagmiConfigParams = __rest(_config, ["projectId", "appName", "appDescription", "appIcon", "appUrl", "wallets", "chains", "transports"]);
    const wcMetadata = computeWalletConnectMetaData({ appName, appDescription, appUrl, appIcon });
    const connectors = connectorsForWallets(wallets, {
        projectId,
        appName,
        appDescription,
        appUrl,
        appIcon,
        walletConnectParameters: { metadata: wcMetadata },
    });
    const config = createConfig(Object.assign(Object.assign({}, wagmiConfigParams), { chains, transports: transports || createDefaultTransports(chains), connectors }));
    useEffect(() => {
        if (!evmContext || !EvmProvider) {
            updateExternalWalletProviderState({ EvmProvider: EvmExternalWalletProvider, evmContext: EvmExternalWalletContext });
        }
    }, []);
    if (!evmContext || !EvmProvider) {
        return null;
    }
    return (_jsx(WagmiProvider, Object.assign({ config: config }, wagmiProviderProps, { children: children })));
}
